module.exports = "<div class=\"modal\">\n  <div class=\"modal-content\">\n    <h5>{{msg}}</h5>\n    <hr>\n    <button class=\"btn btn-primary\" (click)=\"confirm()\">确定</button>\n    <button class=\"btn btn-default\" (click)=\"cancel()\">取消</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/confirmation-box/confirmation-box.com.html
// module id = ./src/app/modules/shared/confirmation-box/confirmation-box.com.html
// module chunks = main